




















































import Vue from 'vue';
import SpinnerArea from '@/components/molecules/spinnerArea/SpinnerArea.vue';
import { SpinnerState } from '@/enums/spinnerState';
import { MessageType } from '@/enums/messageType';
import { dialogueMessageService } from '@/services/dialogueMessageService';
import { PageContent } from '@/api/interfaces/content/app/pageContent';
import PageTemplate from '@/components/templates/pageTemplate/PageTemplate.vue';
import AppRouterLink from '@/components/atoms/appRouterLink/AppRouterLink.vue';
import AppButton from '@/components/atoms/appButton/AppButton.vue';
import { authService } from '@/services/authService';
import { copyTextToClipboard } from '@/services/clipboardService';

export default Vue.extend({
    name: 'Tools',
    components: {
        SpinnerArea,
        AppRouterLink,
        AppButton,
        PageTemplate,
    },
    data: () => {
        return {
            spinner: SpinnerState.off,
            gridSpinner: SpinnerState.off,
            toolsContent: {
                stageContent: {
                    heading: 'Tools',
                },
            } as PageContent,
        };
    },
    created() {
        if (this.$route.query.code === 'unauthorized') {
            dialogueMessageService.show('unauthorized', MessageType.error);
        }
    },
    async mounted() {
        this.spinner = SpinnerState.opaque;

        this.spinner = SpinnerState.off;
    },
    methods: {
        async copyApiToken(): Promise<void> {
            if (authService.token) {
                await copyTextToClipboard(authService.token);
            }
        },
    },
});
